import React, { useEffect, useState, useRef } from "react";
import { collection, query, where, onSnapshot, addDoc, Timestamp, orderBy } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { db, auth } from "../firebaseConfig.js"; // Ajusta con tu configuración Firebase
import "./ListaConversaciones.css";
import "./ChatDetalle.css";

const MensajesOP = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [conversaciones, setConversaciones] = useState([]);
  const [mensajes, setMensajes] = useState([]);
  const [conversacionActiva, setConversacionActiva] = useState(null);
  const [nuevoMensaje, setNuevoMensaje] = useState("");
  const mensajesEndRef = useRef(null);

  // Escuchar el usuario autenticado
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user || null);
    });
    return () => unsubscribeAuth();
  }, []);

  // Cargar conversaciones
  useEffect(() => {
    if (!currentUser?.uid) return;

    const q = query(
      collection(db, "mensajes"),
      where("emisor.uid", "==", currentUser.uid) // Filtra solo por emisor
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const mensajesEmisor = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      cargarConversaciones(mensajesEmisor);
    });

    return () => unsubscribe();
  }, [currentUser]);

  // Función para cargar conversaciones
  const cargarConversaciones = (mensajes) => {
    const conversaciones = mensajes.reduce((acc, mensaje) => {
      const conversacionId =
        mensaje.emisor.uid === currentUser.uid
          ? mensaje.receptor.uid
          : mensaje.emisor.uid;

      if (!acc[conversacionId]) {
        acc[conversacionId] = {
          id: conversacionId,
          usuario: mensaje.emisor.uid === currentUser.uid ? mensaje.receptor : mensaje.emisor,
          mensajes: [],
        };
      }

      acc[conversacionId].mensajes.push(mensaje);
      return acc;
    }, {});

    setConversaciones(Object.values(conversaciones));
  };

  // Cargar mensajes de la conversación activa
  useEffect(() => {
    if (!conversacionActiva?.usuario?.uid || !currentUser?.uid) return;

    const q = query(
      collection(db, "mensajes"),
      where("emisor.uid", "in", [currentUser.uid, conversacionActiva.usuario.uid]),
      where("receptor.uid", "in", [currentUser.uid, conversacionActiva.usuario.uid]),
      orderBy("fechaHora", "asc") // Asegura el orden correcto
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const mensajesActualizados = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMensajes(mensajesActualizados);
    });

    return () => unsubscribe();
  }, [conversacionActiva, currentUser]);

  const enviarMensaje = async () => {
    if (!nuevoMensaje.trim() || !currentUser || !conversacionActiva) return;

    if (nuevoMensaje.length > 600) {
      alert("El mensaje no puede superar los 600 caracteres.");
      return;
    }

    try {
      const nuevoMensajeObj = {
        emisor: { uid: currentUser.uid, nombre: currentUser.displayName },
        receptor: { uid: conversacionActiva.usuario.uid, nombre: conversacionActiva.usuario.nombre },
        mensaje: nuevoMensaje,
        fechaHora: Timestamp.now(),
      };

      const docRef = await addDoc(collection(db, "mensajes"), nuevoMensajeObj);
      setNuevoMensaje("");
      scrollToBottom();

    } catch (error) {
      console.error("Error al enviar el mensaje:", error);
    }
  };

  const scrollToBottom = () => {
    mensajesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [mensajes]);

  return (
    <div className={`contenedor ${conversacionActiva ? "detalle-activo" : ""}`}>
      <div className="lista-conversaciones">
        <h3>Chats</h3>
        {conversaciones.length > 0 ? (
          conversaciones.map((conv) => (
            <div
              key={conv.id}
              className="conversacion-item"
              onClick={() => setConversacionActiva(conv)}
            >
              <div className="info-usuario">
                <h4>{conv.usuario.nombre || "Desconocido"}</h4>
              </div>
            </div>
          ))
        ) : (
          <p>No hay conversaciones disponibles.</p>
        )}
      </div>

      {conversacionActiva && (
        <div className="chat-detalle">
          <header>
            <button className="volver-btn" onClick={() => setConversacionActiva(null)}>
              ←
            </button>
            <span>Conversación con {conversacionActiva.usuario?.nombre || "Desconocido"}</span>
          </header>

          <div className="mensajes">
            {mensajes.map((msg) => (
              <div
                key={msg.id}
                className={`mensaje ${msg.emisor?.uid === currentUser?.uid ? "enviado" : "recibido"}`}
              >
                <p>{msg.mensaje}</p>
                <span className="hora">
                  {msg.fechaHora
                    ? new Date(msg.fechaHora.seconds * 1000).toLocaleString()
                    : "Fecha desconocida"}
                </span>
              </div>
            ))}
            <div ref={mensajesEndRef}></div>
          </div>

          <footer>
            <input
              type="text"
              placeholder="Escribe tu mensaje..."
              value={nuevoMensaje}
              maxLength={600} // Límite de caracteres
              onChange={(e) => setNuevoMensaje(e.target.value)}
            />
            <button onClick={enviarMensaje}>Enviar</button>
          </footer>
        </div>
      )}
    </div>
  );
};

export default MensajesOP;
